import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateDraftCourseRes;
export const updateDraftCourseTodo = createAsyncThunk('updateDraftCourse', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/update_draft_course',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "course_type": data.course_type,
                "course_availability": data.availability,
                "course_title": data.course_title,
                "course_code": data.course_id,
                "cover_image": data.cover,
                "thumbnail_image": data.thumb,
                "duration": data.duration,
                "department_name": data.department,
                "min_view_time": data.min_time,
                "course_id": data.course_unique_id,
                // "revise": data.revise,
                "status": "active",
                "created_by": user_id.vemp_code,
                "contents": data.content,
                "quiz_id": data.quiz_bank,
                "max_time_allowed": data.max_time,
                "max_attemps_count": data.max_attempt,
                "total_marks": data.total_marks,
                "passing_marks": data.passing_marks,
                "participant_allowed": data.review,
                "course_desc": data.course_desc,
                // "revise_reason": data.revise_reason,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return updateDraftCourseRes = res.data
    } catch (error) {
        return updateDraftCourseRes = error.response.data
    }
})